import { ViewModel, View } from "binder"
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ReplacementReasonSelectorViewModel extends MultiSelectorBaseViewModel<ReplacementReason> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<ReplacementReason[]> {
        let result = await ServerConnection.callServer('/Complex/ReplacementReasonServices/ListAllReplacementReasons', {});
        return result.ReplacementReasons.map(x => {
            let r = new ReplacementReason(this);
            r.id = x.Id;
            r.title = `${x.Description} (${x.Code})`;
            return r;
        });
    }
}

export class ReplacementReason extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set symbol(v: string) { this._symbol = v; } public get symbol(): string { return this._symbol; } private _symbol: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}
